// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3ani_","content":"RecentSearches_content__2TcTx"};